import { styled } from "@mui/system";

const severityStyles = {
  success: {
    backgroundColor: "#edf7ed",
    color: "#1e4620"
  },
  info: {
    backgroundColor: "#e5f6fd",
    color: "#014361"
  },
  warning: {
    backgroundColor: "#fff4e5",
    color: "#663c00"
  },
  error: {
    backgroundColor: "var(--Color-Alert-Background-Error, #FBD0D1)",
    color: "var(--Color-Alert-Icon-Error, #5E080B)"
  }
};

export const AlertContainer = styled("div")(({ theme, severity }) => ({
  display: "flex",
  alignItems: "center",
  padding: "8px 12px",
  gap: "8px",
  borderRadius: "8px",
  ...(severityStyles[severity] || {})
}));

export const AlertIcon = styled("div")(({ theme }) => ({
  width: "16px",
  height: "16px"
}));

export const AlertMessage = styled("div")(({ theme }) => ({
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 400
}));
